class WindowManager {
  constructor() {
    this.currentWindow = null;
    this.currentUrl = null;
    this.windowName = "StatementWindow";
    this.windowFeatures = "width=900,height=650,scrollbars=yes,resizable=yes,menubar=no,toolbar=no,location=no,status=no";
  }

  openStatement(url, windowName = null) {
    const targetWindowName = windowName || this.windowName;

    // If a window is already open
    if (this.currentWindow && !this.currentWindow.closed) {
      // Same URL - just focus
      if (this.currentUrl === url) {
        this.currentWindow.focus();
        return this.currentWindow;
      }

      // Different URL - reload with new content
      try {
        this.currentWindow.location.href = url;
        this.currentWindow.focus();
        this.currentUrl = url;

        // Check if reload was successful
        setTimeout(() => {
          if (this.currentWindow.closed) {
            this.currentWindow = null;
            this.currentUrl = null;
            this.openStatement(url, targetWindowName);
          }
        }, 500);

        return this.currentWindow;
      } catch (error) {
        // If cross-origin error, open new window
        console.log("Cross-origin error, opening new window");
        this.currentWindow.close();
        this.currentWindow = null;
        this.currentUrl = null;
      }
    }

    // Open new window
    this.currentWindow = window.open(
      url,
      targetWindowName,
      this.windowFeatures
    );

    if (this.currentWindow) {
      this.currentUrl = url;

      // Setup cleanup on close
      const checkInterval = setInterval(() => {
        if (this.currentWindow.closed) {
          clearInterval(checkInterval);
          this.currentWindow = null;
          this.currentUrl = null;
        }
      }, 1000);

      // Focus the window
      setTimeout(() => {
        if (this.currentWindow) {
          this.currentWindow.focus();
        }
      }, 100);
    }

    return this.currentWindow;
  }

  closeCurrent() {
    if (this.currentWindow && !this.currentWindow.closed) {
      this.currentWindow.close();
      this.currentWindow = null;
      this.currentUrl = null;
    }
  }

  hasOpenWindow() {
    return this.currentWindow && !this.currentWindow.closed;
  }

  getCurrentUrl() {
    return this.currentUrl;
  }
}

// Singleton instance
const windowManager = new WindowManager();
export default windowManager;